global.conmed = global.conmed || {};

conmed.animatedMultiSlide = function ($) {
    'use strict';

    var that = {
        selectors: {

        }
    };

    that.init = function () {

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-show');
                } else {
                    entry.target.classList.add('animate-hide');
                }
            });
        });

        const observerTabs = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-tab-show');
                } else {
                    entry.target.classList.add('animate-tab-hide');
                }
            });
        }, {
            threshold: .8
        });

        const observerTitle = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('show');
                } else {
                    entry.target.classList.add('hide');
                }
            });
        }, {
            threshold: .8
        });

        const observerQuotes = new IntersectionObserver((entries) => {
            entries.forEach((entry, index) => {
                if (index == 0) {
                    let tab = entry.target.parentElement.querySelector('.animate-tabs.hide');
                    if (entry.isIntersecting && entry.target.classList.contains('first') && (!tab || !tab.classList.contains('first'))) {
                        entry.target.classList.remove('hide');
                        //hiddenQuoteElements.forEach((e) => {
                        //    observerQuotes.unobserve(e)
                        //})
                    }
                }
            });
        });

        const observerTabParent = new IntersectionObserver((entries) => {
            entries.forEach((entry, index) => {
                if (index == 0) {
                    let quote = entry.target.parentElement.querySelector('.animate-quote.hide');
                    if (entry.isIntersecting && entry.target.classList.contains('first') && (!quote || !quote.classList.contains('first'))) {
                        entry.target.classList.remove('hide');
                        //hiddenTabParentElements.forEach((e) => {
                        //    observerTabParent.unobserve(e)
                        //})
                    }
                }
            });
        });

        const containerObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    //console.log('IS INTERSECTING')
                    hiddenElements.forEach((el) => observer.observe(el));
                    let firstQuote = document.querySelector('.animate-quote');
                    if (firstQuote.classList.contains('first')) {
                        firstQuote.classList.remove('hide');
                    }
                    //hiddenQuoteElements.forEach((el) => observerQuotes.observe(el));
                    //hiddenTabParentElements.forEach((el) => observerTabParent.observe(el));
                    //window.addEventListener('wheel', preventDefault, { passive: false })
                    setTimeout(function () {
                        scrollComponentStart()
                        containerObserver.unobserve(slideContainer)
                    }, 4000);
                }
            });
        }, {
            threshold: .5
            //rootMargin: '0px 0px -50% 0px',
        });

        let slides = document.querySelectorAll('.animated-slide')
        //let quotes = document.querySelectorAll('.animate-quote-hide')
        let current = 0;
        let currentQuote = 0;

        if (slides.length > 0) {
            slides[0].classList.add('active');
        }

        let scroller = document.querySelector('.animated-multi-slide-container')

        function scrollComponentStart() {
            if (scroller) {
                let pause = false;
                let transition = false;
                scrollComponent(pause, transition);
            }
        }

        function scrollComponent(pause, transition) {
            let slideQuoteHidden = slides[current].querySelector('.animate-quote.hide');
            let slideQuote = slides[current].querySelector('.animate-quote');
            let slideTabsHidden = slides[current].querySelector('.animate-tabs.hide');
            let slideTabs = slides[current].querySelector('.animate-tabs');

            //console.log("doing logic");
            if (slideQuoteHidden && !transition) {
                //event.preventDefault();
                if (!pause && slideTabs) {
                    let row = slides[current].querySelector('.animate-tabs');
                    row.classList.add('hide');
                    pause = true;
                    setTimeout(function () {
                        slideQuoteHidden.classList.remove('hide');
                        slideQuoteHidden.classList.add('animate-quote');
                        transition = true;
                        pause = false;
                    }, 1500);

                    setTimeout(function () {
                        scrollComponent(pause, transition);
                    }, 6000);
                }
            }
            else if (slideTabsHidden && !transition) {
                //event.preventDefault();
                if (!pause && slideQuote) {
                    let currentQuote = slides[current].querySelector('.animate-quote');
                    currentQuote.classList.add('hide');
                    let tabItems = slideTabsHidden.querySelectorAll('.animate-tab');
                    tabItems.forEach(item => {
                        item.classList.remove('animate-tab-show');
                    })
                    pause = true;
                    setTimeout(function () {
                        slideTabsHidden.classList.remove('hide');
                        tabItems.forEach(item => {
                            item.classList.add('animate-tab-show');
                        })
                        transition = true;
                        pause = false;
                    }, 1500);

                    setTimeout(function () {
                        scrollComponent(pause, transition);
                    }, 10000);
                }
            }
            else if (current < slides.length - 1) {
                // Timeout logic for smooth slide transitions
                //event.preventDefault();
                if (!pause) {
                    pause = true;
                    slides[current].classList.remove('active');
                    setTimeout(function () {
                        slides[current].style.display = "none";
                        slides[++current].style.display = "flex";
                    }, 500);
                    setTimeout(function () {
                        slides[current].classList.add('active');
                        pause = false;
                    }, 1000);
                    transition = false;
                    // making sure count lines up between slides and quotes
                    currentQuote = current + 1;

                    setTimeout(function () {
                        scrollComponent(pause, transition);
                    }, 6000);
                }
            }
            else {
                //console.log("done, keep looping");
                if (slideQuoteHidden) {
                    let row = slides[current].querySelector('.animate-tabs');
                    row.classList.add('hide');
                    setTimeout(function () {
                        slideQuoteHidden.classList.remove('hide');
                        slideQuoteHidden.classList.add('animate-quote');
                    }, 1500);
                }
                else if (slideTabsHidden) {
                    let currentQuote = slides[current].querySelector('.animate-quote');
                    currentQuote.classList.add('hide');
                    let tabItems = slideTabsHidden.querySelectorAll('.animate-tab');
                    tabItems.forEach(item => {
                        item.classList.remove('animate-tab-show');
                    })
                    setTimeout(function () {
                        slideTabsHidden.classList.remove('hide');
                        tabItems.forEach(item => {
                            item.classList.add('animate-tab-show');
                        })
                    }, 1500);
                }
                setTimeout(function () {
                    scrollComponent(pause, transition);
                }, 6000);
            }
        }

        const hiddenElements = document.querySelectorAll('.animate-hidden');
        const hiddenTabElements = document.querySelectorAll('.animate-tab-hidden');
        const hiddenTabTitleElements = document.querySelectorAll('.animate-tabs h2');
        const hiddenQuoteElements = document.querySelectorAll('.animate-quote.hide');
        const hiddenTabParentElements = document.querySelectorAll('.animate-tabs.hide');
        const slideContainer = document.querySelector('.animated-multi-slide-container');
        if (document.querySelector('.animated-multi-slide-container')) {
            containerObserver.observe(slideContainer);
            hiddenTabElements.forEach((el) => observerTabs.observe(el));
            hiddenTabTitleElements.forEach((el) => observerTitle.observe(el));
        }
    };
    return that;
}(jQuery);